import React, { useRef, useState } from 'react';
import ButtonFilterRS from '../../../buttons/buttonFilter2/ButtonFilterRS';
import './style.css';
import { useMenuRSStateStore } from '../../../../store/rightSideMenuState/menuRSStateStore';
import { Button, Checkbox, ConfigProvider, DatePicker, Drawer, Menu, Space, Form } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useFilesStore } from '../../../../store/devices/FilesDevicesFromDB';
import { useAuthStore } from '../../../../store/auth/auth';
import { Device } from '../../../../types/Device';
import { Moment } from 'moment';
import { useFileCurrentTypeStore } from '../../../../store/devices/fileCurrentType';
import { useFilterFileStore } from '../../../../store/devices/fileFilterStote';

const items = [
    { label: 'Все', key: 'all' },
    { label: 'Видео', key: 'mpd' },
    { label: 'Фото', key: 'jpg' },
    { label: 'Аудио', key: 'm4a' },
];

const ratingOptions = [
    { label: '1 - наименьшая секретность', value: 0 },
    { label: '2 - низкая секретность', value: 1 },
    { label: '3 - средний уровень секретности', value: 2 },
    { label: '4 - повышенная секретность', value: 3 },
    { label: '5 - высокая секретность', value: 4 },
];

const ToolBarRS: React.FC<{ device: Device | null }> = ({ device }) => {
    const { selectedStateMenuRS } = useMenuRSStateStore();
    const [isModalVisible, setIsModalVisible] = useState(false);
    const { setFileType } = useFileCurrentTypeStore();
    const [currentFileType, setCurrentFileType] = useState('all');
    const { fetchFiles, setPagination, pagination } = useFilesStore();
    const { user, SmartDVRToken } = useAuthStore();
    const { setFileFilterStore } = useFilterFileStore();

    const [form] = Form.useForm();
    const formatDateForAPI = (date: Moment | null): string | undefined => {
        if (!date) return undefined;
        return date.format('YYYY-MM-DDTHH:mm:ss[Z]');
    };

    const showModal = () => setIsModalVisible(true);
    const handleCancel = () => setIsModalVisible(false);

    const handleFileTypeChange = (e: any) => {
        setCurrentFileType(e.key);
        setFileType(e.key);
    };

    const handleSearch = async () => {
        try {
            const values = await form.validateFields();

            setFileFilterStore({
                dateStart: values.startDate ? values.startDate.format() : undefined,
                dateEnd: values.endDate ? values.endDate.format() : undefined,
                rating: values.ratings || [],
            });

            const response = await fetchFiles(
                {
                    deviceUID: device?.UID!,
                    start: formatDateForAPI(values.startDate),
                    end: formatDateForAPI(values.endDate),
                    rating: values.ratings?.length > 0 ? values.ratings : undefined,
                    // fileType: currentFileType !== 'all' ? currentFileType : undefined,
                },
                SmartDVRToken!,
                user?.login!,
                1,
                pagination.pageSize || 50,
            );
            //@ts-ignore
            setPagination((prev) => ({ ...prev, current: 1, total: response?.len }));

            handleCancel();
        } catch (error) {
            console.error('Ошибка при фильтрации файлов:', error);
        }
    };

    const handleReset = async () => {
        form.resetFields();

        setFileFilterStore({
            dateStart: undefined,
            dateEnd: undefined,
            rating: [],
        });

        await fetchFiles(
            {
                deviceUID: device?.UID!,
                start: undefined,
                end: undefined,
                rating: undefined,
                // fileType: undefined,
            },
            SmartDVRToken!,
            user?.login!,
            1,
            pagination.pageSize || 50,
        );

        //@ts-ignore
        setPagination((prev) => ({ ...prev, current: 1 }));
    };

    return (
        <div className="ToolBarRS">
            {selectedStateMenuRS !== 'map' && (
                <div className="Tools">
                    <div className="filesMenu">
                        <ConfigProvider
                            theme={{
                                components: {
                                    Menu: {
                                        itemPaddingInline: 0,
                                        horizontalItemSelectedColor: '#FCE49C',
                                        activeBarHeight: 2,
                                    },
                                },
                            }}
                        >
                            <Menu
                                className="menuLineRS"
                                onClick={handleFileTypeChange}
                                selectedKeys={[currentFileType]}
                                mode="horizontal"
                                items={items}
                            />
                            <ButtonFilterRS onClick={showModal} />
                        </ConfigProvider>
                    </div>
                </div>
            )}

            <Drawer
                className="modalRight"
                open={isModalVisible}
                footer={
                    <div className="FooterFilter">
                        <Button className="buttonModal" onClick={handleSearch}>
                            Поиск
                        </Button>
                        <Button className="buttonModalRed" onClick={handleReset}>
                            Сброс
                        </Button>
                    </div>
                }
                style={{ top: 0, right: 0, margin: 0, width: '400px', height: '100%' }}
                title={
                    <span className="titleModal">
                        <CloseOutlined
                            className="closeBut"
                            onClick={handleCancel}
                            style={{ margin: '0', cursor: 'pointer' }}
                        />
                        Фильтр по файлам
                    </span>
                }
                closable={false}
                bodyStyle={{ padding: 0, height: '100%' }}
            >
                <Form form={form}>
                    <div className="filterPlace">
                        <div className="contentModalRight">
                            <div className="recordingPeriod">
                                <h1 className="h1RecordingPeriod">Период записи:</h1>
                                <Space direction="vertical" size={4}>
                                    <Form.Item
                                        name="startDate"
                                        label={<span style={{ width: 20 }}>C</span>}
                                        rules={[{ required: true, message: 'Укажите дату начала' }]}
                                        // labelCol={{ span: 24 }} // Ширина label
                                        // labelAlign="left"
                                    >
                                        <DatePicker
                                            className="dateStart"
                                            showTime={{ format: 'HH:mm:ss' }}
                                            format="YYYY-MM-DD HH:mm:ss"
                                            size="large"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="endDate"
                                        label={<span style={{ width: 20 }}>До</span>}
                                        rules={[
                                            { required: true, message: 'Укажите дату окончания' },
                                        ]}
                                    >
                                        <DatePicker
                                            className="dateEnd"
                                            showTime={{ format: 'HH:mm:ss' }}
                                            format="YYYY-MM-DD HH:mm:ss"
                                            size="large"
                                        />
                                    </Form.Item>
                                </Space>
                            </div>
                            <div className="Urgency">
                                <h1 className="h1RecordingPeriod">Секретность:</h1>
                                <ConfigProvider
                                    theme={{
                                        token: {
                                            colorPrimary: '#4D4E65',
                                        },
                                    }}
                                >
                                    <Form.Item name="ratings">
                                        <Checkbox.Group options={ratingOptions} />
                                    </Form.Item>
                                </ConfigProvider>
                            </div>
                        </div>
                    </div>
                </Form>
            </Drawer>
        </div>
    );
};

export default ToolBarRS;
